"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationTokenPurpose = void 0;
exports.ConversationTokenPurpose = {
    SignedUrl: "signed_url",
    ShareableLink: "shareable_link",
};
